var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":_vm.type,"color":_vm.color,"dense":_vm.dense,"outlined":"outlined","text":_vm.text}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }